module.exports = "/public/webpack/img/icon_help_categories_ads_321c601ddb2c8c2218162c5830336ba5de.png";